
import { Component, Vue, Prop, Watch } from 'vue-property-decorator'
import { getAntOrderDetail } from '@/api/task/antOrderReview'
@Component({
  name: 'editAccount',
  components: {},
})
export default class extends Vue {
  @Prop({ required: true }) ordernumber!: any

  private back() {
    this.$emit('close')
  }

  private listLoading: boolean = false
  private detailForm: any = {}
  private async getDetail() {
    try {
      this.listLoading = true
      // delObjEmptyKey(data)
      await getAntOrderDetail(this.ordernumber).then((res: any) => {
        this.detailForm = res
        this.listLoading = false
      })
    } catch (e) {
      this.listLoading = false
    }
  }

  mounted() {}
}
